<!--  -->
<template>
     <div class='wrapper box_v'>
        <!-- <div class="title">社保人申请状态</div> -->
        <Title t='社保人申请状态'/>
		<div class="itemwrapper box">
			<div v-for="(item,index) in list" :key="`cheifage_${index}`" class="item box box_f1 box box_v">
				<div class="itemTitle" :style="'color:'+color[index]">{{item.label}}</div>
				<div class="cylinder" :style="'marginBottom:'+(item.stylePercent*2/3)+'px'">

					<div class="ellipse" :style="'background:'+color[index]"></div>
					<div class="rectangle" :style="'height:'+(2*item.stylePercent+30)+'px;'+'background:'+colors[index]"></div>
				</div>
				<!-- <div class="itemLabel" :style="'color:'+color[index]">{{item.typeName}}</div> -->
                <div class="itemLabel" :style="'color:'+color[index]">其他</div>
			</div>
		</div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Title from './components/title_x'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {Title},
    data() {
    //这里存放数据
        return {
            list:[],
            color:['rgba(35, 224, 241, 1)','rgba(255, 129, 60, 1)','rgba(46, 242, 208, 1)','rgba(153, 153, 153, 1)','rgba(166, 151, 255, 1)'],
            colors:['linear-gradient(90deg, #01A6B5 0%, rgba(0, 228, 255, 0.21) 50%, #03EAFF 100%)','linear-gradient(90deg, #CA5415 0%, rgba(255, 129, 61, 0.21) 50%, #FF813D 100%)','linear-gradient(90deg, #16AC92 0%, rgba(46, 242, 208, 0.21) 49%, #2EF2D0 100%)','linear-gradient(90deg, #A9A9A9 0%, rgba(169, 169, 169, 0.21) 50%, #A9A9A9 100%);','linear-gradient(90deg, #5D52A3 0%, rgba(118, 104, 201, 0.21) 50%, #8879E2 100%);']
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		getData(){
			this.$get(this.urlobj.ageCount).then(res=>{
				let allPeople = 0
				let maxAge = 0
				res.rows.forEach(item=>{
					if(maxAge<item.count) maxAge = item.count
					allPeople += item.count
				})

				this.list = res.rows.map(item=>{
					return {
						...item,
						stylePercent:((item.count/maxAge)*100).toFixed(2),
						percent:((item.count/allPeople)*100).toFixed(2),
						label:((item.count/allPeople)*100).toFixed(2)+'%\n'+item.count+'人'
					}
                })
                
                
			})
		}
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()

        
    },

    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftup.png');
    background-size: 100% 100%;
    height:100%;
}
// .title{
//     font-size: 18px;
//     font-weight: bold;
//     color: #FFFFFF;
//     margin-left: 40px;
//     margin-top: 20px
// }
.colorName{
	color:black;
}
.item{
	justify-content: flex-end
}
.cylinder {
    position: relative;
	transform: rotateX(70deg);
	margin:0 auto
}
 
.ellipse {
    --bkc:red;
    width: 30px;
    height: 30px; 
    // background: #00A0E9;
    background: var(--bkc);
    border-radius: 15px;
}
 
.rectangle {
    width: 30px;
    height: 200px;
    position: absolute;
    background: linear-gradient(90deg, #0084FF 0%, rgba(0, 127, 246, 0.2) 63%, #017CF1 100%);
    top: 0;
    left: 0; 
    border-radius: 15px;
    z-index: -1;
}

.itemTitle{
	font-size: 14px;
	color: #27BBFF;
	text-align: center;
	white-space: pre-wrap;
}
.itemLabel{
	font-size: 14px;
	color: #fff;
	text-align: center
}
.itemwrapper{
	padding:20px 30px;
	height:100%;
}
</style>